export const USE_HELP_AUDIENCE = 'USE_HELP_AUDIENCE';
export const USE_HELP_FRIEND = 'USE_HELP_FRIEND';
export const USE_HELP_HALF = 'USE_HELP_HALF';

export const STORE_HELP_AUDIENCE_USED = 'STORE_HELP_AUDIENCE_USED';
export const STORE_HELP_FRIEND_USED = 'STORE_HELP_FRIEND_USED';
export const STORE_HELP_HALF_USED = 'STORE_HELP_HALF_USED';

export const STORE_FRIEND_HELP = 'STORE_FRIEND_HELP';
export const STORE_AUDIENCE_HELP = 'STORE_AUDIENCE_HELP';
